import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import Popover from '@welldev-group/rcl-popover';
import Button from '@welldev-group/rcl-button';
import { CheckBox } from '@welldev-group/react-comp-lib';

const CheckBoxFilter = props => {
  const { label, options, onChange } = props;
  const [isVisible, setIsVisible] = useState(false);
  const [activeOptions, setActiveOptions] = useState([]);

  const labelText = activeOptions.length
    ? activeOptions.map((option, index) => (
        <>
          {option.label}
          {index < activeOptions.length - 1 && ', '}
        </>
      ))
    : label;

  const optionChecked = selectedOption =>
    activeOptions.some(option => option.value === selectedOption.value);

  const handleSelectedOption = selectedOption => {
    // copy the state
    let activeOptionsCopy = activeOptions.slice();
    // check if selected option is already present in the state
    if (optionChecked(selectedOption)) {
      // if yes, then filter out the entry
      activeOptionsCopy = activeOptionsCopy.filter(
        option => option.value !== selectedOption.value,
      );
    } else {
      // if not, push it in the state
      activeOptionsCopy.push(selectedOption);
    }

    setActiveOptions(activeOptionsCopy);
    onChange(activeOptionsCopy);
  };

  return (
    <div className="filter">
      <Popover
        className="settings__sections-header-locale-wrapper"
        size="small"
        isVisible={isVisible}
        onOutsideClick={() => setIsVisible(false)}
        direction="bottom-right"
        content={
          <ul className="filter__options">
            {options.map(option => (
              <li
                key={option.value}
                className={ClassNames('filter__options-option', {
                  'filter__options-option--active': activeOptions.some(
                    activeOption => activeOption.value === option.value,
                  ),
                })}
              >
                <CheckBox
                  label={option.label}
                  name={option.value}
                  size="small"
                  checked={optionChecked(option)}
                  onChange={() => handleSelectedOption(option)}
                />
              </li>
            ))}
          </ul>
        }
      >
        <Button
          label={labelText}
          className="sorting-pill sorting-pill--small"
          type="default"
          size="normal"
          onClick={() => setIsVisible(!isVisible)}
        />
      </Popover>
    </div>
  );
};

CheckBoxFilter.defaultProps = {
  label: 'Filter Menu',
  options: [],
};

CheckBoxFilter.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  onChange: PropTypes.func.isRequired,
};

export default CheckBoxFilter;
